import React from 'react';
import SaenggibuGenerationForm from './SaenggibuGenerationForm';

const SaenggibuForm = ({ 
  teacherSettings, 
  onSaveSettings = () => {},
  onError,
  auth,
  onLoginRequired,
  uiMode,
  setUiMode,
  showFileHint,
  fileAttachRef,
  scrollToModeButtons,
  scrollToFileAttach,
  initialState,
  batchResetToken
}) => {
  // 교사 설정 기능 완전 제거됨 - 사용자 경험 개선을 위해 단순화

  return (
    <div className="saenggibu-form-container">
      {/* 🚀 간편 생기부 생성 */}
      <div className="saenggibu-quick-section">
      

        {/* 생기부 생성 폼 */}
        <SaenggibuGenerationForm
          auth={auth}
          onError={onError}
          onLoginRequired={onLoginRequired}
          uiMode={uiMode}
          setUiMode={setUiMode}
          showFileHint={showFileHint}
          fileAttachRef={fileAttachRef}
          scrollToModeButtons={scrollToModeButtons}
          scrollToFileAttach={scrollToFileAttach}
          initialState={initialState}
          batchResetToken={batchResetToken}
        />
      </div>
    </div>
  );
};

export default SaenggibuForm;